import * as React from 'react';
import { Box } from '@kite-js/core';
import { ULTheme } from '@theme/types';
import { withTheme } from 'styled-components';
import { BoxProps } from '@kite-js/core/lib/Box/Box';
import { useTranslation } from '@contexts/translation/hooks/useTranslation';
import { MfaPanelCmsWithDefault } from '@components/panels/MfaPanel/MfaPanelCms';
import { LogoCmsWithDefault } from '@components/Logo/LogoCms';

type LogoProps = {
    theme?: ULTheme;
} & BoxProps;

export const Logo: React.FC<LogoProps> = withTheme(({ theme, ...boxProps }) => {
    const translation = useTranslation(LogoCmsWithDefault);
    return (
        <Box {...boxProps}>
            <Box maxHeight="32px" maxWidth="250px" height="auto" width="auto" clone={true}>
                <img alt={translation.LogoAlt ?? 'app-logo'} src={theme.logoUrl} data-cy="app-logo" />
            </Box>
        </Box>
    );
});
